module.exports = __webpack_public_path__ + "/fonts/403.903af79.svg";